import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Booking, BookingService } from '../../../services/Booking/booking.service';
import { MomentFormatPipe } from "../../../moment.pipe";

@Component({
    selector: 'app-dash-booking-card',
    imports: [
    CommonModule,
    RouterModule,
    MomentFormatPipe
],
    templateUrl: './dash-booking-card.component.html',
    styleUrl: './dash-booking-card.component.scss'
})
export class DashBookingCardComponent {
    @Input('booking')
    booking!: Booking;

    constructor(
        public bookingService: BookingService
    )    {

    }

    openBookingDash(booking: Booking) {
        this.bookingService.dashOpen(booking)
    }
}
